module.exports = __webpack_public_path__ + "static/media/flag07.cd53b2e2.svg";